import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import { App } from './App';
import { Providers } from './app/Providers';

const container = document.querySelector('#root');

if (!container) {
    throw new Error('Container should be defined');
}

const root = createRoot(container);

root.render(
    <BrowserRouter>
        <Providers>
            <App />
        </Providers>
    </BrowserRouter>,
);
